import styled from 'styled-components';

export const LoadingStyled = styled.div`
  padding: 20px;
  text-align: center;
  color: '#ffffff';
`;
